import { useCommonContentPageLoadingStore } from 'src/hooks/stores'

export const useCommonContentPageLoading = () => {
  const { commonContentPageLoadingStoreValue, setCommonContentPageLoadingStoreValue } =
    useCommonContentPageLoadingStore()

  const showCommonContentPageLoading = () => {
    setCommonContentPageLoadingStoreValue(true)
  }

  const hideCommonContentPageLoading = () => {
    setCommonContentPageLoadingStoreValue(false)
  }

  return {
    showCommonContentPageLoading,
    hideCommonContentPageLoading,
    isShowCommonContentPageLoading: commonContentPageLoadingStoreValue,
  }
}
